import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastService } from '@capturum/ui/api';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthValidators } from '../validators/auth.validators';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthPageProvider } from '../base/auth-page-provider.interface';
import { LoginConfig } from '../login.config';

@Injectable({
  providedIn: 'root',
})
export class CapturumActivationService implements AuthPageProvider {
  constructor(
    protected readonly config: LoginConfig,
    protected readonly router: Router,
    protected readonly toastService: ToastService,
    protected readonly translateService: TranslateService,
    protected readonly formBuilder: FormBuilder,
  ) {
  }

  public onSuccess(response: { status: string; token: string; }): void {
    this.toastService.success(
      this.translateService.instant('auth.activation.title'),
      this.translateService.instant('auth.activation.success'),
    );
    this.router.navigate(['auth/login']);
  }

  public onFail(error: HttpErrorResponse): void {

  }

  public getForm(): FormGroup {
    return this.formBuilder.group({
      email: [null, Validators.compose([Validators.required, Validators.email])],
      password: [null, Validators.compose([Validators.required, this.config.passwordValidator])],
      password_confirmation: [null, Validators.compose([Validators.required, AuthValidators.equalsField('password')])],
    });
  }
}
